/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface ExistingInitialConsultation { 
    appointmentResourceName: string;
    startDate: string;
    websiteLink: string;
}
export const ExistingInitialConsultation_appointmentResourceName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ExistingInitialConsultation_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ExistingInitialConsultation_websiteLink_Validators: ValidatorFn[] =
    [  Validators.required, ];


